$(document).ready(function () {

    // Track Retailer Clicks
    // $(".js-track-retailer").on("click", function () {
    //     var $label = 'buy online -- '+$(this).attr('title');
    //     analyticsEvent($event = 'event', $category = 'interaction', $action = 'click', $label)
    // });

    // Track Not found hits in Analytics
    if (typeof pageNotFound !== 'undefined') {
        analyticsEvent('Error 404 Page not found', window.location.href, 'Referrer: ' + document.referrer, $nonInteraction = 1);
    }

});